<template>
  <section class="my-lesson-list" v-show="ready">
    <v-container>
      <h1 class="header-title optus-highlight optus-highlight--yellow mb-2">
        Available {{ lessonTerm | capitalize }}s&nbsp;
      </h1>
      <v-row>
        <v-col
          v-for="(lesson, index) in activeLessons"
          :key="index"
          lg="4"
          md="6"
          cols="12"
        >
          <lesson-card
            client-list
            :lesson="lesson"
            @startClassLesson="startClassLesson"
          ></lesson-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import LessonCard from '@/modules/lesson/views/LessonCard'
import Lesson from '@/modules/lesson/models/Lesson'
import { mapState } from 'vuex'

export default {
  name: 'LessonList',
  components: {
    LessonCard
  },
  data() {
    return {
      ready: false
    }
  },
  computed: {
    ...mapState(['lessonTerm']),
    activeLessons() {
      return Lesson.all()
    }
  },
  async mounted() {
    this.$store.state.loading = true
    await Lesson.dispatch('fetch', this.$route.meta.type)
    setTimeout(() => {
      this.ready = true
      this.$store.state.loading = false
    })
  },
  methods: {
    async startClassLesson(lesson) {
      let slug = lesson.slug
      let link = ''
      let base_url = window.location.origin
      if (process.env.NODE_ENV === 'production') {
        link = 'lessons/client'
      } else {
        base_url = `${process.env.VUE_APP_LESSON}/client`
      }

      window.open(`${base_url}/${link}?slug=${slug}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.my-lesson-list {
  .minus-gap {
    margin-left: -8px;
    margin-right: -8px;
  }
}
</style>
